// Animation
import { motion } from "framer-motion";
import styled from "styled-components";
import { pageAnimation, titleAnim } from "../animation";
// Scroll at the Top of the window
import ScrollTop from "../components/ScrollTop";

const ContactUs = () => {
  return (
    <ContactStyle
      variants={pageAnimation}
      initial="hidden"
      animate="show"
      exit="exit"
    >
      <Title>
        <Hide>
          <motion.h2 variants={titleAnim}>Get in touch:</motion.h2>
        </Hide>
      </Title>
      <div>
        <Hide>
          <Social variants={titleAnim}>
            <a
              href="mailto:asifazimi.me@gmail.com"
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                color: "inherit",
                width: "100%",
              }}
            >
              <Circle />
              <h2>Email</h2>
            </a>
          </Social>
        </Hide>
        <Hide>
          <Social variants={titleAnim}>
            <a
              href="https://github.com/asifazimi"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                color: "inherit",
                width: "100%",
              }}
            >
              <Circle />
              <h2>GitHub</h2>
            </a>
          </Social>
        </Hide>
        <Hide>
          <Social variants={titleAnim}>
            <a
              href="https://linkedin.com/in/asifazimi"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                color: "inherit",
                width: "100%",
              }}
            >
              <Circle />
              <h2>LinkedIn</h2>
            </a>
          </Social>
        </Hide>
        <Hide>
          <Social variants={titleAnim}>
            <a
              href="https://www.instagram.com/asif__azimi/profilecard/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: "flex",
                alignItems: "center",
                textDecoration: "none",
                color: "inherit",
                width: "100%",
              }}
            >
              <Circle />
              <h2>Instagram</h2>
            </a>
          </Social>
        </Hide>
      </div>
      <ScrollTop />
    </ContactStyle>
  );
};

const ContactStyle = styled(motion.div)`
  padding: 5rem 10rem;
  color: white;
  min-height: 90vh;

  @media (max-width: 1300px) {
    padding: 3rem 5rem;
  }

  @media (max-width: 768px) {
    padding: 2rem 2rem;
    min-height: auto;
  }

  @media (max-width: 480px) {
    padding: 1.5rem 1rem;
  }
`;

const Title = styled.div`
  margin-bottom: 4rem;
  color: black;

  h2 {
    color: white;
  }

  @media (max-width: 768px) {
    margin-bottom: 2rem;
  }
`;

const Hide = styled.div`
  overflow: hidden;
`;

const Circle = styled.div`
  border-radius: 50%;
  width: 3rem;
  height: 3rem;
  background: white;
`;

const Social = styled(motion.div)`
  display: flex;
  align-items: center;
  cursor: pointer;

  a {
    h2 {
      margin: 2rem;
    }
  }

  @media (max-width: 768px) {
    justify-content: center;

    a {
      h2 {
        margin: 1rem;
        font-size: 1.5rem;
      }
    }
  }

  @media (max-width: 480px) {
    a {
      h2 {
        font-size: 1.2rem;
      }
    }
  }
`;

export default ContactUs;
